import { NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME, NEXUS_CONNECTED_APP_BLOCKS } from './nexusIntegrationsDemo.js'

export const WEBSITE_CRM_DOCUMENTS_TABLE_DATA = [
  {
    Document: NEXUS_CRM_INTEGRATION_ARTIFACT_FILE_NAME,
    Format: 'Markdown',
    Purpose: 'API integration guide and endpoint reference',
  },
  {
    Document: 'NexusB2B — Procurement Site.html',
    Format: 'HTML App',
    Purpose: 'Live procurement website preview',
  },
  {
    Document: 'NexusB2B — CRM Test Report.md',
    Format: 'Markdown',
    Purpose: 'Demo-user test results and trigger verification',
  },
]

export const WEBSITE_CRM_WRAP_UP_MARKDOWN =
  '🎯 **NexusB2B is production-ready** — website live in preview, CRM trigger verified, and payment + email integrations on standby. Open any document above to review details in the artifact panel.'

export const WEBSITE_CRM_HOSTING_CTA_MARKDOWN =
  '☁️ Do you want me to host it on **Google Cloud** (already connected)? Or tell me the location you wish to host the site.'

export const WEBSITE_CRM_REFINEMENT_CTA_MARKDOWN =
  '**How does the website look?** Review the procurement site preview and CRM test report above.\n\nWould you like any refinements to the UI, integrations, or demo flow — or shall I **proceed with deployment and platform testing** on Google Cloud? Reply **yes** when you\'re ready to move forward.'

export const WEBSITE_CRM_GCP_APP_BLOCK = {
  type: 'appConnection',
  title: 'Google Cloud',
  description: 'Application is already connected. Ready to deploy the NexusB2B site.',
  iconUrl: 'https://cdn.simpleicons.org/googlecloud/4285F4',
  status: 'connected',
  toolkitSlug: 'google-cloud',
  tags: ['OAuth2', 'Cloud Run'],
}

/** Index of the CRM test log inside {@link buildWebsiteCrmConnectFinalBlocks} (before agent-switch splice). */

export const WEBSITE_CRM_CRM_TEST_LOG_BLOCK_INDEX = 8

export const WEBSITE_CRM_CONNECTED_APP_BLOCKS = NEXUS_CONNECTED_APP_BLOCKS

export const SITE_ROOT = '/DOSense/agent/home/nexus-b2b-site'

/** @param {string} relPath @param {string} content @param {number} [durationMs] @param {string} [stepNarration] @param {string} [nextRelPath] @param {number} [narrationIndex] */
